import service from '../services/prorrogaEntregable.service';

export default {
  namespaced: true,

  state: {
    entregable: null,
    empleados: [],
    empleadosMeta: null,
    documentos: [],
  },

  getters: {
    getEntregable: state => state.entregable,
    getEmpleados: state => state.empleados,
    getEmpleadosMeta: state => state.empleadosMeta,
    getDocumentos: state => state.documentos,
  },

  mutations: {
    setEntregable(state, data) {
      state.entregable = data;
    },
    setEmpleados(state, { items, meta }) {
      state.empleados = items;
      state.empleadosMeta = meta;
    },
    setDocumentos(state, items) {
      state.documentos = items;
    },
    agregarDocumento(state, documento) {
      state.documentos = [
        ...state.documentos,
        { id: Date.now(), ...documento },
      ];
    },
    eliminarDocumento(state, id) {
      state.documentos = state.documentos.filter(d => d.id !== id);
    },
    resetState(state) {
      state.entregable = null;
      state.empleados = [];
      state.empleadosMeta = null;
      state.documentos = [];
    },
  },

  actions: {
    async fetchEntregable({ commit }, { consultoriaId, entregableId }) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.fetchDetalleEntregableProrroga(consultoriaId);
        const data = response.data.data;
        const { entregables } = data;
        const raw = entregables.find(e => String(e.id) === String(entregableId)) || {};
        const consultoria = {
          id: consultoriaId,
          nombre: data.nombreConsultoria,
          fechaInicio: data.fechaInicioConsultoria,
          fechaFin: data.fechaFinConsultoria,
          ultimaModificacion: data.ultimaModificacion?.split('T')[0] || null,
          modificadoPor: data.modificadoPor || '',
        };
        const entregable = {
          ...raw,
          fechaInicio: raw.fechaInicio?.split('T')[0] || null,
          fechaFin: raw.fechaFin?.split('T')[0] || null,
          fechaInicioActividades: raw.fechaInicioActividades?.split('T')[0] || null,
          fechaFinActividades: raw.fechaFinActividades?.split('T')[0] || null,
          fechaInicioEvaluacion: raw.fechaInicioEvaluacion?.split('T')[0] || null,
          fechaFinEvaluacion: raw.fechaFinEvaluacion?.split('T')[0] || null,
          fechaEstimadaPago: raw.fechaEstimadaPago?.split('T')[0] || null,
          consultoria,
        };
        commit('setEntregable', entregable);
        commit('setDocumentos', []);
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    agregarDocumento({ commit }, documento) {
      commit('agregarDocumento', documento);
    },

    eliminarDocumento({ commit }, id) {
      commit('eliminarDocumento', id);
    },

    async guardarProrroga({ state }, { id, formulario }) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const toApiDate = (val) => {
          if (!val) return '';
          const ddmmyyyy = val.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
          if (ddmmyyyy) return `${ddmmyyyy[3]}-${ddmmyyyy[2]}-${ddmmyyyy[1]}`;
          return val.substring(0, 10);
        };
        const formData = new FormData();
        formData.append('fecha_fin_nueva', toApiDate(formulario.fechaFinEntregable));
        formData.append('comentario', formulario.comentario || '');
        formData.append('fecha_estimada_pago', toApiDate(formulario.fechaEstimadaPago));
        formData.append('fecha_inicio_evaluacion', toApiDate(formulario.fechaInicioEvaluacion));
        formData.append('fecha_fin_evaluacion', toApiDate(formulario.fechaFinEvaluacion));
        formData.append('fecha_inicio_actividades', toApiDate(formulario.fechaInicioActividades));
        formData.append('fecha_fin_actividades', toApiDate(formulario.fechaFinActividades));
        state.documentos.forEach((doc, i) => {
          formData.append(`adjuntos[${i}][nombre]`, doc.nombre);
          formData.append(`adjuntos[${i}][archivo]`, doc.archivo);
        });
        const response = await service.guardarProrroga(id, formData);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async actualizarConsultoriaProrroga(_, { consultoriaId, fechaFin, justificacion, archivos }) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const formData = new FormData();
        formData.append('fecha_fin', fechaFin);
        if (justificacion) formData.append('justificacion', justificacion);
        if (archivos && archivos.length) {
          archivos.forEach(archivo => formData.append('archivos[]', archivo));
        }
        const response = await service.actualizarConsultoriaProrroga(consultoriaId, formData);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    resetState({ commit }) {
      commit('resetState');
    },
  },
};
